import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "../css/NotFound.css";
import NotFoundImage from "../../assets/404.png";  
import Header from "./Header/Header";
import Footer from "./Footer/footer";


const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Page Not Found - Froth TestOps</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to homepage or contact support for assistance." />
        <link rel="canonical" href="https://frothtestops.com/404" />
      </Helmet>
            <Header />

      <div className="nf-container container-fluid">
      <div className="row align-items-center justify-content-center min-vh-100">
        
        {/* Left Side */}
        <div className="col-lg-6 col-12 nf-left">
          <div className="nf-content">
            <h1 className="nf-code">404</h1>

            <h2 className="nf-title">
              Ooops!
              <br />
              Page Not Found
            </h2>

            <p className="nf-text">
              This page doesn’t exist or was removed.
              <br />
              We suggest you go back home.
            </p>

            <button
              className="btn nf-btn"
              onClick={() => navigate("/")}
            >
              Back To Home
            </button>
          </div>
        </div>

        {/* Right Side */}
        <div className="col-lg-6 col-12 text-center">
          <img
            src={NotFoundImage}
            alt="404 Illustration"
            className="img-fluid nf-image"
          />
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default NotFound;